export class Grafico {
    anio: string;
    cantidadDevolucion: string;
    cantidadRetiro: string;
    mes: string;
}

export class Cuadro {
    completado: string;
    descripcionServicio: string;
    facturado: string;
    liquidado: string;
    planificado: string;
    tipoItem: string;
    tipoServicio: string;
    tramitador: string;
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/domain/dashboard.ts